import { ReactNode } from 'react';
import { IconSearchOff } from '@rossum/ui/icons/tabler';
import { useGridApiContext } from '@rossum/ui/x-data-grid-pro';
import { EmptyStateRadar } from '../../lib/EmptyStateRadar';

type OverlayProps = {
  description?: ReactNode;
};

declare module '@mui/x-data-grid-pro' {
  interface NoRowsOverlayPropsOverrides {
    description?: ReactNode;
  }
  interface NoResultsOverlayPropsOverrides {
    description?: ReactNode;
  }
}

const NoRowsOverlay = ({ description }: OverlayProps) => {
  const apiRef = useGridApiContext();
  const title = apiRef.current.getLocaleText('noRowsLabel');
  return <EmptyStateRadar title={title} description={description} />;
};

const NoResultsOverlay = ({ description }: OverlayProps) => {
  const apiRef = useGridApiContext();
  const title = apiRef.current.getLocaleText('noResultsOverlayLabel');
  return (
    <EmptyStateRadar
      title={title}
      description={description}
      iconProps={{ Icon: IconSearchOff, iconSize: 36 }}
    />
  );
};

export const MuiDataGrid = {
  defaultProps: {
    slots: {
      noRowsOverlay: NoRowsOverlay,
      noResultsOverlay: NoResultsOverlay,
    },
  },
};
